import { createPortal } from 'react-dom';
import { Box } from '@mui/material';

import { IntroductionButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../NatureOfBusinessFormProvider/types';
import Introduction from '@Components/Introduction';

export const INCOME_STRUCTURE_INTRODUCTION_ID = 'income-structure-introduction';

const IncomeStructureIntroduction = () => {
  const { watch, getValues } = useNatureOfBusinessForm();
  const introduction = getValues(
    'incomeStructure.introduction'
  ) as IIncomeStructureFormValues['introduction'];

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const introductionEl = document.getElementById(
    INCOME_STRUCTURE_INTRODUCTION_ID
  );

  const [isCompletedTh, isCompletedEn] = watch([
    'incomeStructure.completedSection.isCompletedTh',
    'incomeStructure.completedSection.isCompletedEn',
  ]);

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        introductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="โครงสร้างรายได้"
              setOpen={open}
              fieldPath="incomeStructure.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          introductionEl
        )}
    </>
  );
};

export default IncomeStructureIntroduction;
